export default "__VITE_ASSET__BhsDspPd__"